module.exports = __webpack_public_path__ + "img/disconnected-pink.84160561.png";